import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box } from '@mui/material';
import { debounce } from 'lodash';
import {
  getVehicle,
  patchUpdateVehicle,
  postAddVehicle,
} from 'redux/actions/UserVehicle';
import { getOnBoardCompliance } from 'redux/actions/UserCompliance';
import { getCar } from 'redux/actions/UserCar';
import CommonTable from 'components/commonTable/CommonTable';
import CommonButtonSubHeader from 'components/commonButtonSubHeader/CommonButtonSubHeader';
import CommonMultiImageForm from 'components/commonMultiImageForm/CommonMultiImageForm';
import BackDrop from 'components/backDrop/BackDrop';
import { vehicleDialogData, filterdata } from './VehiceData';
import { roleAndPermissionEnum } from 'utils/rolesPermissionsEnum';
import { handlePermissions } from 'utils/utils';

const Vehicle = () => {
  const dispatch = useDispatch();
  const [openModel, setOpen] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [image, setImage] = useState(null);
  const [showOtherComponent, setShowOtherComponent] = useState(false);
  const [openEditVehicle, setOpenEditVehicle] = useState(false);
  const [iconType, setIconType] = useState('Edit');
  const [iconId, setIconId] = useState(null);
  const [defaultValue, setDefaultValue] = useState({});
  const [status, setStatus] = useState('');
  const [search, setSearch] = useState('');
  const companyId = localStorage.getItem('companyId');
  const vehicleList = useSelector(
    (state) => state?.userVehicle?.userVehicle?.data
  );
  const loader = useSelector((state) => state?.userVehicle?.loading);
  const carList = useSelector((state) => state?.userCar?.userCar?.data);
  const postAddVehicleSuccess = useSelector(
    (state) => state?.userAddVehicle?.userAddVehicle?.success
  );

  const carOption = carList?.body?.map((val, idx) => {
    return { value: val?.id, label: val?.carType, seater: val?.seater };
  });

  const vehicleData = {
    id: companyId,
    type: 'vendor',
    status: status,
    page: page,
    pageSize: 10,
    search: search,
  };

  useEffect(() => {
    dispatch(getCar());
    dispatch(getVehicle(vehicleData));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getVehicle({ ...vehicleData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getVehicle({
        ...vehicleData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const handleDialog = () => {};

  const tableOnClickRow = (navigate, val) => {
    navigate(`/vehicle/details`, { state: { id: val.id, name: val.carModel } });
  };
  const onImageChange = (val) => {
    setImage(val);
  };

  useEffect(() => {
    if (postAddVehicleSuccess) {
      setShowOtherComponent(true);
    } else {
      setShowOtherComponent(false);
    }
  }, [postAddVehicleSuccess]);

  const onDialog = (val) => {
    const data = {
      ...val,
      carType: 'COC',
      seating: parseInt(val?.seating),
      id: companyId,
      type: 'vendor',
      avtar: image,
    };
    let formData = new FormData();

    Object.keys(data).map((val) => {
      formData.append(val, data[val]);
    });
    dispatch(postAddVehicle(formData));
  };

  const onClickMoreIcon = (val, iconType) => {
    setIconId(val.id);
    const data = {
      ...val,
      carType: 'COC',
      seating: parseInt(val?.seating),
      id: val.id,
      type: 'vendor',
      avtar: image,
    };
    const value = data;
    setDefaultValue(value);
    setIconId(data.id);
    let statusAction = '';
    switch (iconType) {
      case 'Deactivate':
        statusAction = 'InActive';
        break;
      case 'Activate':
        statusAction = 'Active';
        break;
      case 'Block':
        statusAction = 'Blocked';
        break;
      case 'Unblock':
        statusAction = 'Active';
        break;
      default:
        break;
    }
    if (iconType === 'Delete') {
    } else if (iconType === 'Edit') {
      setIconType(iconType);
      setOpenEditVehicle(true);
    } else if (iconType === 'Upload Compliance') {
      setIconType(iconType);
      setOpenEditVehicle(true);
      const profileData = {
        vehicleId: val.id,
        type: 'vehicleRegistration',
      };
      setShowOtherComponent(true);
      dispatch(getOnBoardCompliance(profileData));
    } else if (statusAction !== '') {
      const profileData = {
        vehicleId: data.id,
        type: 'vendor',
        page:page,
        pageSize:rowsPerPage,
        search:search,
        data: {
          isApproved: statusAction,
        },
      };
      dispatch(patchUpdateVehicle({ ...profileData, parentId: companyId }));
    }
  };

  const handleClose = () => {
    setOpenEditVehicle(false);
    setShowOtherComponent(false);
  };

  const onFilterChange = (val) => {
    setPage(0);
    setStatus(val);

    const driverFilterData = {
      ...vehicleData,
      status: val?.toString(),
      page: 0,
    };
    dispatch(getVehicle(driverFilterData));
  };

  const onRestFilter = () => {
    setStatus('');
    const driverFilterData = {
      ...vehicleData,
      status: '',
    };
    dispatch(getVehicle(driverFilterData));
  };

  const onSearch = debounce((e) => {
    setPage(0);
    setSearch(e);
    const searchFilterData = {
      ...vehicleData,
      search: e,
      page: 0,
    };
    dispatch(getVehicle(searchFilterData));
  }, 1000);

  const closeUploadCompliance = () => {
    setShowOtherComponent(false);
  };

  const addButton = () => {
    setOpen(true);
    closeUploadCompliance();
  };

  const handleCloseVehicle = () => {
    setOpen(false);
  };

   //roles and permissions 
   const roleAndPermissions = useSelector((state) => state?.getRolesAndPermissions?.rolesAndPermissions);
   const vehicleRoleEnum = roleAndPermissionEnum.vehicle
   const accessForAdd = handlePermissions(roleAndPermissions, vehicleRoleEnum.moduleKey, {defaultAllAccess: vehicleRoleEnum.all, customAccess: vehicleRoleEnum.add});
   const accessForOnlyView = handlePermissions(roleAndPermissions, vehicleRoleEnum.moduleKey, {customAccess: vehicleRoleEnum.subVendorView});
   const accessForOnlyEdit = handlePermissions(roleAndPermissions, vehicleRoleEnum.moduleKey, {customAccess: vehicleRoleEnum.subVendorEdit});
 
   const accessForOnlyBlock = handlePermissions(roleAndPermissions, vehicleRoleEnum.moduleKey, {customAccess: vehicleRoleEnum.subVendorBlock});
 
   const accessForOnlyAdd = handlePermissions(roleAndPermissions, vehicleRoleEnum.moduleKey, {customAccess: vehicleRoleEnum.subVendorAdd});
 
   const viewMoreIcon = (accessForAdd || accessForOnlyEdit ||accessForOnlyBlock )
   const addButtonPermission = (accessForAdd ||accessForOnlyAdd )

  return (
    <Box className="vehicle-container">
      <CommonButtonSubHeader
        btnName={addButtonPermission && 'Vehicle'}
        filterdata={filterdata}
        btnAction={addButton}
        tabName={'company'}
        // search={'true'}
        height={true}
        onFilterChange={onFilterChange}
        onRestFilter={onRestFilter}
        onSearchQuery={onSearch}
        defaultStatus={status}
      />
      {loader ? (
        <Box>
          <BackDrop/>
        </Box>
      ) : (
        <CommonTable
          tabName={'vehicle'}
          data={vehicleList}
          companyTable={true}
          tableOnClickRow={tableOnClickRow}
          handleDialog={handleDialog}
          handleChangePage={handleChangePage}
          handleChangeRowsPerPage={handleChangeRowsPerPage}
          page={page}
          rowsPerPage={rowsPerPage}
          onClickMoreIcon={onClickMoreIcon}
          isClickable={true}
          viewMoreIcon={!viewMoreIcon}
        />
      )}

      <CommonMultiImageForm
        open={openModel}
        className="mb20"
        handleClose={handleCloseVehicle}
        formData={vehicleDialogData(carOption)}
        button={'dialogButton'}
        onSubmittBtn={onDialog}
        selectType={'Create'}
        type={'Vehicle'}
        onImageChange={onImageChange}
        showOtherComponent={showOtherComponent}
        tabName="vehicle"
      />

      {openEditVehicle && (
        <CommonMultiImageForm
          open={openEditVehicle}
          handleClose={handleClose}
          formData={vehicleDialogData(carOption)}
          button={'dialogButton'}
          onSubmittBtn={onDialog}
          selectType={'edit'}
          type={'Upload Vehicle Compliance'}
          defaultValues={defaultValue}
          onImageChange={onImageChange}
          showOtherComponent={showOtherComponent}
          tabName="vehicle"
          vehicleId={iconId}
        />
      )}
    </Box>
  );
};

export default Vehicle;
